import React from "react";
import { FaRegClock, FaMapMarkerAlt, FaHandsHelping } from "react-icons/fa";

const cards = [
  {
    icon: FaRegClock,
    title: "Service Times",
    lines: [
      ["Sunday Worship", "1:30 PM"],
      ["Friday Prayer Meeting", "7:00 PM"],
    ],
  },
  {
    icon: FaMapMarkerAlt,
    title: "Where to Find Us",
    lines: [
      ["Address", "1485 Mary Avenue"],
      ["", "Cambridge, ON  N3H 4N8"],
    ],
  },
  {
    icon: FaHandsHelping,
    title: "What to Expect",
    lines: [
      ["Come as you are", "all are welcome"],
      ["Warm fellowship", "Spirit-filled worship"],
    ],
  },
];

const Visit = () => {
  return (
    <section id="visit" className="w-full bg-maroon py-20 px-4 text-white md:py-28">
      <div className="mx-auto max-w-[1240px]">
        <div className="mx-auto max-w-2xl text-center">
          <p className="section-label text-peach">Plan Your Visit</p>
          <h2 className="mt-3 font-serif text-3xl font-bold sm:text-4xl">
            We'd love to see you this week
          </h2>
          <p className="mt-4 text-white/80">
            New here? Here is everything you need to know before you join us.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {cards.map(({ icon: Icon, title, lines }) => (
            <div
              key={title}
              className="rounded-2xl bg-white/5 p-8 text-center ring-1 ring-white/10 transition hover:bg-white/10"
            >
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-terracotta text-white">
                <Icon size={24} />
              </span>
              <h3 className="mt-5 font-serif text-2xl font-bold text-peach">
                {title}
              </h3>
              <div className="mt-4 space-y-2">
                {lines.map(([label, value], i) => (
                  <p key={i} className="text-white/90">
                    {label && (
                      <span className="block text-sm text-white/60">{label}</span>
                    )}
                    <span className="font-semibold">{value}</span>
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a href="#contact" className="btn-primary">
            Get Directions &amp; Contact
          </a>
        </div>
      </div>
    </section>
  );
};

export default Visit;
